import React, { Component } from 'react';
import ImagesColumn from '../image-display/ImagesColumn';

class Favorites extends Component {

	constructor(props) {
		super(props);
		this.state = {
			favoredPhotos: []
		};

		this.props.router.setRouteLeaveHook(
      		this.props.route,
      		this.closeModalBeforeLeaving.bind(this)
    	);	
	}

	componentWillReceiveProps(nextProps) {
		let images = JSON.parse(localStorage.getItem('flickrPhotosAppReact'));
		if (!images) {
			images = [];
		}
     	let cols = nextProps.picCols.map((colNum, index) => {
			return (
				<div key={index.toString()} id={'container'+colNum} className="container col-md-4 col-sm-6 col-xs-12">
					<ImagesColumn colNum={index} totalCols={nextProps.picCols} photos={images} disableFavs="true"></ImagesColumn>
				</div>
			);
		});
     	this.setState({
     		favoredPhotos: images,
     		cols: cols
     	});
	}

	componentDidMount() {
		this.props.dispatchAdjustUI();
	}

	closeModalBeforeLeaving() {
		this.props.dispatchCloseModal();
		this.props.dispatchCompletedAdjustUI();
	}

	render() {	
		return (
			<div id="main-content-container">
				<div className="title">Found {this.state.favoredPhotos.length} favorites: </div>
				<div className="container-fluid">
					<div className="row">
						{this.state.cols}
					</div>
				</div>
			</div>
		)
	}

}

export default Favorites;



/** WEBPACK FOOTER **
 ** ./src/favorites/Favorites.js
 **/